import {
  IdentityCorner,
  IdentityGrid,
  IdentityLineGroup,
  IdentityPanel,
  IdentityQrFrame,
  IdentitySpine,
  identityCssVariables
} from "./designSystem";
import { getMirrorHangerSvgPath } from "./designSystem/mirrorTagDesign";

function PaddockMirrorTag({ settings, headerLogo, qr, vehicleYear, vehicleMakeModel, showProductOverlay = true }) {
  const hasVehicle = settings.showCarName && Boolean(vehicleYear || vehicleMakeModel);
  return (
    <div className={`paddock-mirror-tag base-${settings.baseTheme} finish-${settings.finish} ${hasVehicle ? "has-vehicle" : ""} ${showProductOverlay ? "product-preview" : "artwork-only"}`} style={identityCssVariables(settings.accentColor, settings.baseTheme)}>
      <IdentityGrid variant="technical" className="mirror-tag-grid" />
      <IdentityPanel variant="stepped" className="mirror-tag-top-panel" />
      <IdentitySpine variant="tall" side="left" className="mirror-tag-spine" />
      <IdentityLineGroup variant="telemetry" className="mirror-tag-lines" />
      <IdentityCorner variant="strong" position="top-right" />
      <IdentityCorner variant="strong" position="bottom-left" />
      <span className="mirror-tag-right-rail" aria-hidden="true" />

      <section className="mirror-tag-brand" aria-label="MyBuildID branding">
        <img src={headerLogo} alt="MyBuildID" />
        {hasVehicle && <div className="mirror-tag-vehicle" title={[vehicleYear, vehicleMakeModel].filter(Boolean).join(" ")}>
          {vehicleYear && <span>{vehicleYear}</span>}
          {vehicleMakeModel && <strong>{vehicleMakeModel}</strong>}
        </div>}
      </section>

      <IdentityQrFrame variant="high-visibility" className="mirror-tag-qr">{qr}</IdentityQrFrame>

      <section className="mirror-tag-cta">
        <span aria-hidden="true" />
        <strong>Scan to view my build</strong>
        <b>MYBUILDID.COM</b>
      </section>
      {showProductOverlay && <div className="mirror-product-overlay" aria-hidden="true"><svg className="mirror-hanger-cutout" viewBox="0 0 1000 2714.2857" preserveAspectRatio="none" focusable="false"><defs><pattern id="mirror-hanger-checker" width="48" height="48" patternUnits="userSpaceOnUse"><rect width="48" height="48" fill="#171717" /><rect width="24" height="24" fill="rgba(255,255,255,.055)" /><rect x="24" y="24" width="24" height="24" fill="rgba(255,255,255,.055)" /></pattern></defs><path d={getMirrorHangerSvgPath()} fill="url(#mirror-hanger-checker)" /></svg><span className="mirror-product-edge" /></div>}
    </div>
  );
}

export default PaddockMirrorTag;
